import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type AgentKnowledgeId = ID<"agentKnowledge">;
export const agentKnowledgeIdFormat = idFormat<AgentKnowledgeId>({
  prefix: "agk_",
});

export type MerchantKnowledgeId = ID<"merchantKnowledge">;
export const merchantKnowledgeIdFormat = idFormat<MerchantKnowledgeId>({
  prefix: "mkn_",
});

export type SuggestedMerchantKnowledgeId = ID<"suggestedMerchantKnowledge">;
export const suggestedMerchantKnowledgeIdFormat =
  idFormat<SuggestedMerchantKnowledgeId>({ prefix: "smk_" });

export type ProductKnowledgeId = ID<"productKnowledge">;
export const productKnowledgeIdFormat = idFormat<ProductKnowledgeId>({
  prefix: "pkn_",
});

export type FaqKnowledgeId = ID<"faqKnowledge">;
export const faqKnowledgeIdFormat = idFormat<FaqKnowledgeId>({
  prefix: "fkn_",
});

export type ProductMetafieldKnowledgeId = ID<"productMetafieldKnowledge">;
export const productMetafieldKnowledgeIdFormat =
  idFormat<ProductMetafieldKnowledgeId>({ prefix: "pmk_" });
